import React from 'react';
import TooltipPopover from 'components/TooltipPopover';

interface LegendItem {
  label: string;
  content?: string;
  icon: string;
}

interface LegendsData {
  [key: string]: LegendItem[];
}

const legendsData: LegendsData = {
  set1: [
    { label: 'On', icon: `${process.env.PUBLIC_URL}/static/img/organic.svg` },
    { label: 'Off', icon: `${process.env.PUBLIC_URL}/static/img/paid.svg` },
  ],
  set2: [
    { label: 'Total', icon: `${process.env.PUBLIC_URL}/static/img/total_ao.svg` },
    { label: 'Organic', icon: `${process.env.PUBLIC_URL}/static/img/total_green_ao.svg` },
    { label: 'Paid', icon: `${process.env.PUBLIC_URL}/static/img/paid_blue_ao.svg` },
  ],
  set3: [
    { label: 'Cost', content:'auto_optimize_page.cost_vs_expected_cost.cost', icon: `${process.env.PUBLIC_URL}/static/img/total_green_ao.svg` },
    { label: 'Expected Cost', content:'auto_optimize_page.cost_vs_expected_cost.expected_cost', icon: `${process.env.PUBLIC_URL}/static/img/organic_ao.svg` },
  ]
};

interface CustomLegendProps {
  legendSet: keyof LegendsData;
  onLegendClick: (label: string) => void;
  visibility: Record<string, boolean>;
}

const CustomLegend: React.FC<CustomLegendProps> = ({ legendSet, onLegendClick, visibility }) => {
  const legends = legendsData[legendSet];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingLeft: '10px' }}>
      {legends.map((legend, index) => (
        <TooltipPopover 
            key={index}
            content={legend.content}
            type='dashed'
            side='top'
          >
        <div
          key={index}
          style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', cursor: 'pointer', opacity: visibility[legend.label] ? 1 : 0.5 }}
          onClick={() => onLegendClick(legend.label)}
        >
          <img
            src={legend.icon}
            alt={legend.label}
            style={{ width: '16px', height: '16px', marginRight: '10px' }}
          />
          <span>{legend.label}</span>
        </div>
        </TooltipPopover>
      ))}
    </div>
  );
};

export default CustomLegend;
